import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import type { AccountMappingRow, UpdateAccountMapping } from '@dcc-erp/shared';

import { api, apiJson } from '../api';

const key = (companyId: string | undefined) => ['account-mappings', companyId] as const;

export function useAccountMappings(companyId: string | undefined) {
  return useQuery({
    queryKey: key(companyId),
    queryFn: () => api<AccountMappingRow[]>(`/companies/${companyId}/account-mappings`),
    enabled: !!companyId,
  });
}

export function useUpdateAccountMapping(companyId: string | undefined) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ key: k, data }: { key: string; data: UpdateAccountMapping }) =>
      apiJson<UpdateAccountMapping, AccountMappingRow>(
        'PATCH',
        `/companies/${companyId}/account-mappings/${k}`,
        data,
      ),
    onSuccess: () => qc.invalidateQueries({ queryKey: key(companyId) }),
  });
}
